import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import NProgress from 'nprogress';
import { setIcon } from '@/utils/dom';
// progress bar style
import 'nprogress/nprogress.css';

import { routes } from './routes';
import { ROUTES_WHITE_LIST, ROLES_WHITE_LIST } from '@/config/constant';

NProgress.configure({ showSpinner: true });

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

let roleName;

/**
 * 判断是否有权限并跳转到相应的路由
 * @param { array } menu
 * @param { array } routes
 * @param { object } 跳转路由
 * @param { function } next函数
 * @returns boolean
 */
function skip(menu, routes, to, next) {
	// 是否存在菜单列表中
	let result1 = matchRoute(menu, to);
	// 是否存在路由列表中
	let result2 = matchRoute(routes, to);
	if (result1 && result2) {
		// 如果是德育管理员 只有五育应用一个一级菜单, 则不能跳转首页
		if (roleName == '五育并举管理员' && to.path == '/home') {
			next('/performance-evaluation');
		} else if (roleName == '学校巡检管理员' && to.path == '/home') {
			// 如果是学校巡检管理员 只有安全中心  一个一级菜单, 则不能跳转首页
			next('/view-online');
		} else {
			next();
		}
	} else if (result1 === false && result2 === true) {
		/*
		api: menu/user-menu新增分类字段menu_category，前端根据分类获取menuList，
		手动修改url切换路由地址时不再验证当前静态路由是否存在已经分类的菜单列表中
		*/
		// console.log(401, menu, to);
		// 如果是德育管理员 只有五育应用一个一级菜单, 则不能跳转首页
		if (roleName == '五育并举管理员' && to.path == '/home') {
			next('/performance-evaluation');
		} else if (roleName == '学校巡检管理员' && to.path == '/home') {
			// 如果是学校巡检管理员 只有安全中心  一个一级菜单, 则不能跳转首页
			next('/view-online');
		} else {
			next();
		}
	} else if (result2 === false) {
		next({
			path: '/404'
		});
	}
}
/**
 * 通过path判断当前路由是否存在
 * @param routes
 * @param route
 */
function matchRoute(routes, route) {
	return routes.some(item => {
		if (
			(item.fullPath || item.path) === route.path ||
			route.path === '/500' ||
			route.path === '/404' ||
			route.path === '/401'
		) {
			return true;
		} else {
			if (item.children && item.children.length > 0) {
				return matchRoute(item.children, route);
			}
		}
	});
}

const addErrorLog = error => {
	let info = {
		type: 'route',
		message: JSON.stringify(error)
	};
	store.dispatch('addErrorLog', info);
};

/*
 ********************* 路由跳转验证 *******************************
 * 理论上， 所有路由都需要进行跳转验证，通过设置白名单，免除路由跳转验证
 */
router.beforeEach((to, from, next) => {
	NProgress.start();
	// 当前域名下的基本信息是否为空
	let appInfo = sessionStorage.getItem('appInfo');
	if (!appInfo || appInfo === '{}') {
		let domain = window.location.hostname;
		store.dispatch('getLogoByDomain', { domain }).catch(e => {
			console.log(e);
		});
	} else {
		appInfo = JSON.parse(appInfo);
		setIcon(appInfo.favicon);
		if (!Object.keys(store.state.user.appInfo).length) {
			let payload = {
				appInfo
			};
			store.commit('SET_APP_INFO', payload);
		}
		if (!document.title || document.title === 'undefined') {
			document.title = appInfo.name;
		}
	}
	/* 是否存在token */
	if (localStorage.token) {
		// 如果跳转的页面是登录页面， 则重定向到主页
		if (to.name === 'login') {
			next({ path: '/' });
			NProgress.done();
		} else {
			if (store.state.user.menu.length === 0) {
				store
					.dispatch('getUserInfo')
					.then(res => {
						// console.log('user info', res);
						roleName = res.data.roleName;
						// 身份：['系统管理员', '运营人员', '学校', '学校职工', '代理商', '商户'];
						let roleId = res.data.roleId;
						let lang = localStorage.lang ? localStorage.lang : 'cn';

						store
							.dispatch('getMenuMapSort')
							.then(() => {
								let menu_category = '';
								let currentPage = window.sessionStorage.currentPage;
								if (currentPage) {
									let { index } = JSON.parse(currentPage);
									if (index) {
										menu_category = index;
									} else {
										// 如果是德育管理员 只有五育应用一个一级菜单, 则不能跳转首页
										menu_category = roleName == '五育并举管理员' ? 7 : 1;
										// 如果是学校巡检管理员 只有安全中心  一个一级菜单, 则不能跳转首页
										menu_category = roleName == '学校巡检管理员' ? 3 : 1;
									}
								} else {
									// 如果是德育管理员 只有五育应用一个一级菜单, 则不能跳转首页
									menu_category = roleName == '五育并举管理员' ? 7 : 1;
									// 如果是学校巡检管理员 只有安全中心  一个一级菜单, 则不能跳转首页
									menu_category = roleName == '学校巡检管理员' ? 3 : 1;
								}
								store
									.dispatch('getMenuMap', {
										lang,
										role_id: roleId,
										menu_category
									})
									.then(res => {
										/* 路由免验证 或者 身份免验证 */
										if (
											ROUTES_WHITE_LIST.indexOf(to.name) !== -1 ||
											ROLES_WHITE_LIST.indexOf(
												store.state.user.userInfo.role
											) !== -1
										) {
											next();
										} else {
											/* 判断是否有权限跳转 */
											skip(res.menu, routes, to, next);
										}
									})
									.catch(err => {
										console.error(err);
										store.dispatch('logout').then(() => {
											next({
												name: 'login',
												query: {
													redirect: to.name,
													type: 'api',
													cause: 'menu'
												}
											});
										});
									});
							})
							.catch(err => {
								console.error(err);
								store.dispatch('logout').then(() => {
									next({
										name: 'login',
										query: {
											redirect: to.name,
											type: 'api',
											cause: 'menuSort'
										}
									});
								});
							});
					})
					.catch(err => {
						console.error(err);
						store.dispatch('logout').then(() => {
							next({
								name: 'login',
								query: {
									redirect: to.name,
									type: 'api',
									cause: 'user_info'
								}
							});
						});
					});
			} else {
				/* 路由免验证 或者 身份免验证 */
				if (
					ROUTES_WHITE_LIST.indexOf(to.name) !== -1 ||
					ROLES_WHITE_LIST.indexOf(store.state.user.userInfo.role) !== -1
				) {
					next();
				} else {
					/* 判断是否有权限跳转 */
					skip(store.state.user.menu, routes, to, next);
				}
			}
		}
	} else {
		if (ROUTES_WHITE_LIST.indexOf(to.name) !== -1) {
			next();
		} else {
			next({
				name: 'login',
				query: {
					redirect: to.name,
					cause: 'token'
				}
			});
		}
	}
});

router.afterEach(() => {
	NProgress.done(); // finish progress bar
});

/**
 * 捕捉路由跳转错误
 */
router.onError(error => {
	console.log('router error', error);
	addErrorLog(error);
});

export default router;
